import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  GridFlag,
  TenantFilterCell,
  TestGroupFilterCell,
  BooleanValuesFilterCell,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
}) => {
  const dataColumns = [
    {
      field: 'uc_ossi_run_id',
      title: 'Run Id',
      editable: false,
      show: true,
      width: '500px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.uc_ossi_run_id}
        </td>
      ),
    },
    {
      field: 'TenantName',
      title: 'Tenant',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 150,
      filterCell: (props) =>
        TenantFilterCell({
          ...props,
          filterType: 'dropdown',
        }),
    },
    {
      field: 'uc_ossi_grp',
      title: 'Group',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      filterCell: (props) =>
        TestGroupFilterCell({
          ...props,
          filterType: 'dropdown',
        }),
    },
    {
      field: 'uc_ossi_disable_flg',
      title: 'Disabled?',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanValuesFilterCell,
    },
    {
      field: 'uc_ossi_descr',
      title: 'Description',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
    },
    {
      field: 'ins_user_id',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ins_dt',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ins_dt',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'last_upd_user_id',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'last_upd_dt',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'last_upd_dt',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
